import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    status: '',
    userdata: {},
    filtri_tracking: {},
    filtri_PesiVolumi: {},
    list_cappario: {},
    items_tracking: [],
    items_PesiVolumi: [],
    changePassword: 0,
    cappario: [],
    cappario_ricevuto: false,
    version: "1.0",
    scadenza: 3600000,
    //scadenza: 10000,
    timer: null,
    servicePath: 'https://webservices.arcospedizioni.it'
    //servicePath: 'https://localhost:5001'
  },  
  mutations: {
    auth_request(state) {
      state.status = 'loading'
    },
    errore_cappario(state, msg){
      //
    },
    stato_cappario(state, msg){
      state.cappario_ricevuto = true;
    },
    cappario (state, cap){
      cap.forEach(el=>{
        var a = el.trpcap.trim();
        if(a in state.list_cappario){
          state.list_cappario[a].push(el);
        }
        else{
          state.list_cappario[a] = [];
          state.list_cappario[a].push(el);
        }
        //state.list_cappario[a] = el;
      })
      state.cappario = cap;
      
      
      //console.log(state);
    },
    auth_success(state, userdata) {
      state.status = 'success'
      state.token = userdata.token
      state.userdata = userdata
      state.cappario = userdata.cappario
      state.list_cappario = [];
      
      state.filtri_tracking = {}
      state.items_tracking = []
      state.filtri_bollettazione = {}
      state.items_bollettazione = []
    },
    auth_error(state) {
      state.status = 'error'
      state.filtri_tracking = {}
      state.items_tracking = []
      state.filtri_bollettazione = {}
      state.items_bollettazione = []
    },
    logout(state) {
      state.status = ''
      state.token = ''
      state.userdata = {}
      state.filtri_tracking = {}
      state.items_tracking = []
      state.filtri_bollettazione = {}
      state.items_bollettazione = []
    },
    setFiltriBollettazione(state, filtri) {
      state.filtri_bollettazione = filtri
    },
    setFiltriTracking(state, filtri) {
      state.filtri_tracking = filtri
    },
    setFiltriPesiVolumi(state, filtri){
      state.filtri_PesiVolumi = filtri
    },
    setItemsPesiVolumi(state, items) {
      state.items_PesiVolumi = items
    },
    setItemsTracking(state, items) {
      state.items_tracking = items
    },
    setItemsBollettazione(state, items) {
      state.items_bollettazione = items
    }
  },
  actions: {
    getCappario({ commit }){
      axios({ url: this.state.servicePath + '/api/Login/GetCappario', method: 'GET'})
        .then(r=>{
          //this.state.cappario_ricevuto = false;
          commit('cappario', r.data)
          commit('stato_cappario', true)
          
        })
        .catch(err =>{
          console.log(err)
          commit('errore_cappario', true);
        });
    },
    ImpostaScollegamento({ commit }){
      if(this.state.timer === null)
        this.state.timer = setTimeout(() => location.reload(true), this.state.scadenza);
      else{
        clearTimeout(this.state.timer);
        this.state.timer = setTimeout(() => location.reload(true), this.state.scadenza);
      }
    },
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({ url: this.state.servicePath + '/api/Login/Login', data: user, method: 'POST' })
          .then(resp => {
            const token = resp.data.token
            const userdata = resp.data
            this.changePassword = resp.data.mustChangePassword
            // localStorage.setItem('token', token)
            axios.defaults.headers.common['Authorization'] =  token
            commit('auth_success', userdata)
            resolve(resp)
            return (this.changePassword)
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('token')
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status
  }
})